import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    topContent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      width: '100%',
      marginTop: -theme.spacing(8),
      marginBottom: theme.spacing(4),
    },
    addButton: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: theme.palette.primary.main,
    },
    subtitleTop: {
      color: theme.palette.text.secondary,
      paddingBottom: theme.spacing(2),
    },
    subtitleBottom: {
      color: theme.palette.text.secondary,
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
    },
    headerText: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
);

export default useStyles;
